import React, { useState } from 'react';
import { ReactComponent as BenchmarkFlag } from "../../static/assets/benchmark-flag-long.svg";
import { ReactComponent as BenchmarkFlagOrange } from "../../static/assets/benchmark-flag-long-orange.svg";

export function SliderFlags({ range, getBenchmarkOffset }) {
    const [showBenchmarkDetails, setShowBenchmarkDetails] = useState(false);
    const [showToBeDetails, setShowToBeDetails] = useState(false);

    const toggleBenchmarkDetails = () => setShowBenchmarkDetails(prev => !prev);
    const toggleToBeDetails = () => setShowToBeDetails(prev => !prev);

    return (
        <>
            {range?.benchmark && (
                <div
                    className="benchmark-container"
                    style={{
                        left: `${((range['benchmark'] - range['min_value']) / (range['max_value'] - range['min_value']) * 100)}%`,
                        marginLeft: getBenchmarkOffset ? getBenchmarkOffset(range['benchmark'] / range['max_value']) : '0',
                        cursor: 'pointer',
                    }}
                    onClick={toggleBenchmarkDetails}
                    onTouchEnd={toggleBenchmarkDetails}
                >
                    <BenchmarkFlag className="benchmark-flag" style={{cursor: 'pointer'}}/>
                    {
                        showBenchmarkDetails &&
                            <div style={{zIndex: 1}}>
                                {range['benchmark']}&nbsp;{range['unit_prefix']}
                            </div>
                    }
                </div>
            )}

            {range?.to_be && (
                <div
                    className="benchmark-container"
                    style={{
                        left: `${((range['to_be'] - range['min_value']) / (range['max_value'] - range['min_value']) * 100)}%`,
                        marginLeft: getBenchmarkOffset ? getBenchmarkOffset(range['to_be'] / range['max_value']) : '0',
                        cursor: 'pointer',
                    }}
                    onClick={toggleToBeDetails}
                    onTouchEnd={toggleToBeDetails}
                >
                    <BenchmarkFlagOrange className="benchmark-flag" style={{cursor: 'pointer'}}/>
                    {
                        showToBeDetails &&
                            <div style={{zIndex: 1}}>
                                {range['to_be']}&nbsp;{range['unit_prefix']}
                            </div>
                    }
                </div>
            )}
        </>
    );
}
